import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {
    deletedAssociations, deletedRestoreAssociations,
    setAssociations,
    setAssociationsRestoreData,
    updateAssociations
} from "./associationsSlice";
import {IRolesAssociationCreate} from "../types";


const GetAssociations = createAsyncThunk(
    "get/associations",
    async (_, {dispatch, rejectWithValue,}) => {
        try {
            const response = await request.get("/role-submodule");

            dispatch(setAssociations(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const GetItemAssociations=createAsyncThunk(
    "get/item/associations",
    async (id:number,{ rejectWithValue,})=>{
        try {
            const response = await request.get(`/role-submodule/${id}`);


            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
)

const SetAssociations = createAsyncThunk(
    "post/associations",
    async (data: IRolesAssociationCreate, {rejectWithValue,}) => {
        try {
            const response = await request.post("/role-submodule", data);


            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const EditAssociations = createAsyncThunk(
    "put/associations",
    async (data: any, {dispatch, rejectWithValue,}) => {
        try {
            const response = await request.put(`/role-submodule/${data.id}`, data);

            dispatch(updateAssociations(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteAssociations = createAsyncThunk(
    "delete/associations",
    async (id: number, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.delete(`/role-submodule/${id}`);

            dispatch(deletedAssociations(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetDeleteAssociations = createAsyncThunk(
    "get/delete/associations",
    async (_, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.get(`/role-submodule/deleted-items`);

            dispatch(setAssociationsRestoreData(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const RestoreDeleteAssociations = createAsyncThunk(
    "restore/delete/associations",
    async (id: number, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.post(`/role-submodule/restore/${id}`);

            dispatch(deletedRestoreAssociations(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
export {
    GetAssociations,
    SetAssociations,
    EditAssociations,
    DeleteAssociations,
    GetDeleteAssociations,
    RestoreDeleteAssociations,
    GetItemAssociations
}